module.exports = __webpack_public_path__ + "logo-white.png?c766e4c8cc9363ee253bd04e6a83182e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-white.png
// module id = 419
// module chunks = 0